import React from 'react';
import { DriveTabs } from '@common/constants/logbook';
import { useLogbookContext } from '@context';
import './index.scss';

type TabProps = {
  title: string;
  isActive: boolean;
  onClick: () => void;
  amount: number;
};

const Tab: React.FC<TabProps> = ({ title, isActive, onClick, amount }: TabProps) => (
  <div className="tab-container">
    <div className="tab-title-container" onClick={onClick}>
      <p className={!isActive ? 'tab-title' : 'tab-title-active'}>{title}</p>
      <div className={!isActive ? 'tab-amount-container' : 'tab-amount-container-active'}>
        <p>{amount}</p>
      </div>
    </div>
    {isActive && <div className="tab-title-line-active" />}
  </div>
);

const Tabs: React.FC = () => {
  const { setSelectedTab, selectedTab, tabsNumbers } = useLogbookContext();

  const handleClick = (tab: DriveTabs) => {
    setSelectedTab(tab);
  };

  const chooseDoneTab = () => handleClick(DriveTabs.done);
  const chooseToDoTab = () => handleClick(DriveTabs.toDo);

  return (
    <div className="tabs-wrapper">
      <div className="tabs-container">
        <Tab
          isActive={selectedTab === DriveTabs.done}
          title="DONE drives"
          onClick={chooseDoneTab}
          amount={tabsNumbers[0]}
        />
        <Tab
          amount={tabsNumbers[1]}
          isActive={selectedTab === DriveTabs.toDo}
          title="To DO drives"
          onClick={chooseToDoTab}
        />
      </div>
    </div>
  );
};

export default Tabs;
